module.exports = __webpack_public_path__ + "img/proverb01.1931c63d.png";